import React, { useState,useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  Button,
  InputGroup,
  Card,
} from 'react-bootstrap';
import { list_channels } from '../../../../utils/crm_services';


function Channels_link  ({user_id, permission, onSet, token }) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'channelName', dir: 'asc' });
   const [initialRows, setinitialRows] = useState([ ]);
  
    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
  
      result = [...result].sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
  
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;
      });
  
      return result;
    }, [searchTerm, sortConfig, initialRows]);
  
    // --- Handlers ---
    const toggleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
        }
        return { key, dir: 'asc' };
      });
    };

    const add_linked_channel = (id, title) => {
      onSet(id, title);
  
  };
    useEffect(() => {
      fetchloadChannel(token);
    }, []); 
  
      async function fetchloadChannel(token) {
            const channelData = await list_channels(token);
            if (channelData==="INVALID"){
                navigate("/");
            }
            else{
              const tempCH = channelData.map((celement, index) => {
                return {
                  id: celement.id,
                  name: celement.name,
                  country: celement.country,
                  index:index
                };
              });
              setinitialRows(tempCH);
              
            }
      }
   
  
 
  
    // Icono flecha ↑↓
    const SortIcon = ({ col }) =>
      sortConfig.key === col ? (sortConfig.dir === 'asc' ? '↑' : '↓') : '↕';
  
    // ---------- UI ----------
    return (
      <div className="container py-4">
        
        {/* Barra de búsqueda + menús */}
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
            <Form.Control
              placeholder="Search Channel..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </InputGroup>
        </div>

        {/* Tabla */}
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr >
                <th onClick={() => toggleSort('channelName')} role="button">
                  Reseller <SortIcon col="channelName" />
                </th>
                <th onClick={() => toggleSort('country')} role="button">
                  Country <SortIcon col="country" />
                </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} onClick={() => add_linked_channel(row.id, row.name)} >
                <td>{row.name}</td>
                <td>{row.country}</td>
              </tr>
              
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
};

export default Channels_link;
